import React from "react";
import UserLayout from "../components/UserLayout";
import MyShopsPage from "../components/myshops/page";

export default function MyShopsLayoutPage() {
  return (
    <UserLayout>
      <MyShopsPage />
    </UserLayout>
  );
}
